import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute top-[50%] left-0 right-0 text-xs font-bold text-highlight" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return ($data.cartItemCount > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_v_icon, {
          icon: "cart-filled",
          class: "cart-filled",
          width: 26,
          height: 27,
          "width-mobile": 24,
          "height-mobile": 25
        }),
        _createElementVNode("span", _hoisted_1, _toDisplayString($data.cartItemCount), 1)
      ], 64))
    : (_openBlock(), _createBlock(_component_v_icon, {
        key: 1,
        icon: "cart-empty",
        class: "cart-empty",
        width: 26,
        height: 27,
        "width-mobile": 24,
        "height-mobile": 25
      }))
}